import { IPlayerProps, Player } from '@lottiefiles/react-lottie-player';
import React, { FunctionComponent } from 'react';
import circularLoaderJSON from './circularLoader.json';

type CircularLoaderProps = {
  /** Loader height is the same as its width */
  width?: number;
  className?: string;
};

/**
 * Animated loader using the React component for the Lottie Web Player - https://github.com/LottieFiles/lottie-react
 */
export const CircularLoader: FunctionComponent<CircularLoaderProps> = ({ width = 24, ...props }) => {
  const options: IPlayerProps = {
    background: 'transparent',
    speed: 1,
    loop: true,
    autoplay: true,
    src: circularLoaderJSON,
    rendererSettings: {
      preserveAspectRatio: 'xMinYMin slice',
    },
    style: { margin: 0, width: width ?? 24, height: width ?? 24 },
    className: props.className,
  };

  return <Player {...options} />;
};

export default CircularLoader;
